import { Link } from "react-router-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function GoogleButton({ offer = "", label = "Continuer avec Google" }) {
  const start = () => {
    if (offer) sessionStorage.setItem("kavizio_offer", offer);
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/accueil";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-3">
        <span className="flex-1 h-px bg-[#E9E4DA]" />
        <span className="text-xs text-gray-400">ou</span>
        <span className="flex-1 h-px bg-[#E9E4DA]" />
      </div>
      <button type="button" data-testid="google-auth-btn" onClick={start}
        className="w-full py-3 rounded-2xl border border-[#E0DACE] bg-white font-semibold text-sm flex items-center justify-center gap-2 hover:bg-[#F6F4EF] transition-colors">
        <svg width="17" height="17" viewBox="0 0 48 48" aria-hidden="true">
          <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.6 2.4 30.2 0 24 0 14.6 0 6.5 5.4 2.6 13.2l7.8 6.1C12.3 13.2 17.6 9.5 24 9.5z" />
          <path fill="#4285F4" d="M46.1 24.6c0-1.6-.1-2.8-.4-4.1H24v8.1h12.6c-.3 2.1-1.6 5.2-4.6 7.3l7.6 5.9c4.5-4.2 6.5-10.2 6.5-17.2z" />
          <path fill="#FBBC05" d="M10.4 28.7c-.5-1.5-.8-3-.8-4.7s.3-3.2.8-4.7l-7.8-6.1C1 16.3 0 20 0 24s1 7.7 2.6 10.8l7.8-6.1z" />
          <path fill="#34A853" d="M24 48c6.2 0 11.5-2 15.6-5.6l-7.6-5.9c-2 1.4-4.8 2.4-8 2.4-6.4 0-11.7-3.7-13.6-9.2l-7.8 6.1C6.5 42.6 14.6 48 24 48z" />
        </svg>
        {label}
      </button>
      <p className="text-xs text-gray-500 text-center">
        Réservé au compte du patron. Les employés se connectent via leur invitation.{" "}
        <Link to="/contact" className="underline">Besoin d'aide ?</Link>
      </p>
    </div>
  );
}
